import React, { useState } from 'react';
import { authAPI } from '../api/endpoints';
import { useAuth } from '../context/AuthContext';

// Permite fijar una contrasena (cuentas creadas con Google) o cambiarla.
const PasswordSection = () => {
  const { user, refreshUser } = useAuth();
  const hasPassword = user?.has_password;
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setDone(false);
    setLoading(true);
    try {
      await authAPI.setPassword(next, hasPassword ? current : undefined);
      await refreshUser();
      setCurrent('');
      setNext('');
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo guardar la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-card">
      <h2>{hasPassword ? 'Cambiar contraseña' : 'Crear contraseña'}</h2>
      {!hasPassword && (
        <p className="form-hint">
          Tu cuenta entra con Google. Crea una contraseña para poder ingresar también con usuario y contraseña.
        </p>
      )}
      {error && <div className="form-alert error">{error}</div>}
      {done && <div className="form-alert success">Contraseña actualizada.</div>}
      <form onSubmit={handleSubmit}>
        {hasPassword && (
          <div className="form-group">
            <label>Contraseña actual</label>
            <input
              type="password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              required
            />
          </div>
        )}
        <div className="form-group">
          <label>Nueva contraseña (mínimo 8 caracteres)</label>
          <input
            type="password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
            required
            minLength={8}
          />
        </div>
        <button type="submit" className="btn btn-navy" disabled={loading}>
          {loading ? 'Guardando...' : 'Guardar contraseña'}
        </button>
      </form>
    </div>
  );
};

export default PasswordSection;
